module.exports = function($) {
  var PlaceholderField, defaultPromptEnabled, inputEmpty, setPlaceholder;
  PlaceholderField = $.fn.PlaceholderField = function() {
    if (PlaceholderField.hasNativePlaceholderSupport()) {
      return this;
    }
    return this.each(function() {
      return PlaceholderField.initPlaceholder($(this));
    });
  };
  PlaceholderField.hasNativePlaceholderSupport = function() {
    return _.all([document.createElement('input'), document.createElement('textarea')], function(elem) {
      return elem.placeholder != null;
    });
  };
  inputEmpty = function($input) {
    return /^\s*$/.test($input.val());
  };
  PlaceholderField.initPlaceholder = function($input) {
    var focusin, focusout;
    focusin = function() {
      if (defaultPromptEnabled($input)) {
        return $input.val('').removeClass('prompting');
      }
    };
    (focusout = function() {
      if (inputEmpty($input)) {
        return setPlaceholder($input);
      }
    })();
    return $input.on({
      focusin: focusin,
      focusout: focusout
    });
  };
  setPlaceholder = function($input) {
    var ref;
    $input.addClass('prompting');
    return $input.val((ref = $input.attr('placeholder')) != null ? ref : $input.attr('title'));
  };
  defaultPromptEnabled = function($input) {
    var placeholder, sansWhitespace;
    sansWhitespace = function(val) {
      return val.replace(/\s/g, '');
    };
    placeholder = $input.attr('placeholder') || $input.attr('title') || '';
    return sansWhitespace($input.val()) === sansWhitespace(placeholder);
  };
  return PlaceholderField;
};

//# sourceMappingURL=data:application/json;base64,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
